module.exports = function($) {
  var PlaceholderField, defaultPromptEnabled, inputEmpty, setPlaceholder;
  PlaceholderField = $.fn.PlaceholderField = function() {
    if (PlaceholderField.hasNativePlaceholderSupport()) {
      return this;
    }
    return this.each(function() {
      return PlaceholderField.initPlaceholder($(this));
    });
  };
  PlaceholderField.hasNativePlaceholderSupport = function() {
    return _.all([document.createElement('input'), document.createElement('textarea')], function(elem) {
      return elem.placeholder != null;
    });
  };
  inputEmpty = function($input) {
    return /^\s*$/.test($input.val());
  };
  PlaceholderField.initPlaceholder = function($input) {
    var focusin, focusout;
    focusin = function() {
      if (defaultPromptEnabled($input)) {
        return $input.val('').removeClass('prompting');
      }
    };
    (focusout = function() {
      if (inputEmpty($input)) {
        return setPlaceholder($input);
      }
    })();
    return $input.on({
      focusin: focusin,
      focusout: focusout
    });
  };
  setPlaceholder = function($input) {
    var ref;
    $input.addClass('prompting');
    return $input.val((ref = $input.attr('placeholder')) != null ? ref : $input.attr('title'));
  };
  defaultPromptEnabled = function($input) {
    var placeholder, sansWhitespace;
    sansWhitespace = function(val) {
      return val.replace(/\s/g, '');
    };
    placeholder = $input.attr('placeholder') || $input.attr('title') || '';
    return sansWhitespace($input.val()) === sansWhitespace(placeholder);
  };
  return PlaceholderField;
};

//# sourceMappingURL=data:application/json;base64,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
